import api from './NotificationInstance';

export default api;
